import { IconButton, Text } from "@/elements"
import { XMarkIcon } from "@heroicons/react/24/outline"
import { MessageProps, DefaultStreamChatGenerics, Avatar, useChannelActionContext } from "stream-chat-react"

export const ThreadHeader: React.FC<MessageProps<DefaultStreamChatGenerics>> = ({ message }) => {
  const { closeThread } = useChannelActionContext()

  const replyCount = message.reply_count
  const threadParticipants = message.thread_participants || []

  const replyDisplayText = replyCount === 1 ? "reply" : "replies"

  return (
    <div className="mt-4 flex flex-row justify-between">
      <div>
        <div className="flex flex-row gap-1">
          {threadParticipants.map((participant: any) => {
            return (
              <div className="participant" key={participant.id}>
                <Avatar image={participant.image} name={participant.name} />
              </div>
            )
          })}
        </div>
        <Text>
          {replyCount} {replyDisplayText}
        </Text>
      </div>
      <div>
        <IconButton Icon={XMarkIcon} onClick={closeThread} />
      </div>
    </div>
  )
}
